import { ReactElement } from 'react';

export const BackgroundSignIn = (): ReactElement => {
  return (
    <div className="absolute left-0 top-0 h-full w-full flex-1 overflow-hidden bg-sign-in bg-cover bg-center bg-no-repeat" />
  );
};
